import React from "react";

import styled from "styled-components";
import ImageGallery from "react-image-gallery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faFilePdf,
  faMapMarkerAlt,
  faUtensils,
} from "@fortawesome/free-solid-svg-icons";

const FooterIcon = styled(FontAwesomeIcon)`
  margin: auto;
`;

const ColFlex = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-evenly;
`;

const images = [
  {
    original: "/kitchenL3.webp",
    thumbnail: "/kitchenL3.webp",
  },
  {
    original: "/kitchenL1.webp",
    thumbnail: "/kitchenL1.webp",
  },
  {
    original: "/kitchenL2.webp",
    thumbnail: "/kitchenL2.webp",
  },
];

const foodImages = [
  {
    original: "/food3.webp",
    thumbnail: "/food3.webp",
  },
  {
    original: "/food9.webp",
    thumbnail: "/food9.webp",
  },
  {
    original: "/food6.webp",
    thumbnail: "/food6.webp",
  },
  {
    original: "/food2.webp",
    thumbnail: "/food2.webp",
  },
  {
    original: "/food1.webp",
    thumbnail: "/food1.webp",
  },
];

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  padding: 1rem;
`;

const FlexContainer = styled.div`
  margin-left: 1rem;
  margin-right: 1rem;
  margin-bottom: 0.25rem;
  margin-top: 0.25rem;
  line-height: 1rem;
  flex-basis: 0;
  flex-grow: 1;
`;

const BorderImg = styled.img`
  width: 95%;
  margin-left: auto;
  margin-right: auto;
`;

const TeamImg = styled.img`
  width: 50%;
  margin-left: auto;
  margin-right: auto;
`;

const SideBySideContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

function KitchenLinks() {
  return (
    <SideBySideContainer className="mb1">
      <ColFlex className="tac">
        <div>
          <h3>Visit Us</h3>
        </div>
        <div>
          <span>
            <FooterIcon icon={faUtensils} style={{ marginRight: "0.5rem" }} />
            <a
              href="https://www.dishcult.com/restaurant/lubberkitchen?sortOrder=0&page=1"
              alt="Book a table at Lubber Kitchen"
              className="  mb1"
            >
              Book a table
            </a>
          </span>
        </div>
        <div>
          <span>
            <FooterIcon
              icon={faMapMarkerAlt}
              style={{ marginRight: "0.5rem" }}
            ></FooterIcon>
            <a
              href="https://maps.app.goo.gl/86wtdEyawnYXNTQC6"
              alt="Find Lubber Kitchen on Google Maps"
              className="  mb1"
            >
              Find us on maps
            </a>
          </span>
        </div>
        <div>
          <span>
            <FooterIcon
              icon={faInstagram}
              style={{ marginRight: "0.5rem" }}
            ></FooterIcon>
            <a
              href="https://www.instagram.com/lubberkitchen/?hl=en"
              alt="Follow Lubber Kitchen on Instagram"
              className="  mb1"
            >
              Follow on Instagram
            </a>
          </span>
        </div>
      </ColFlex>

      <ColFlex className="tac">
        <div>
          <h3>Menus</h3>
        </div>
        <div>
          <span>
            <FooterIcon
              icon={faFilePdf}
              style={{ marginRight: "0.5rem" }}
            ></FooterIcon>
            <a
              href="https://drive.google.com/file/d/1YLEeVpIyYcHLd__6Sh81h_Y1Y_LPnKe-/view?usp=sharing"
              alt="View Lubber Kitchen Menu PDF"
              className="  mb1"
            >
              Lubber Kitchen Menu
            </a>
          </span>
        </div>
        <div>
          <span>
            <FooterIcon
              icon={faFilePdf}
              style={{ marginRight: "0.5rem" }}
            ></FooterIcon>
            <a
              href="https://drive.google.com/file/d/1pLgXGKnBqGFFwSuTjADR-rl_TMY-JEcZ/view?usp=sharing"
              alt="View Internal Hire Menu PDF"
              className="  mb1"
            >
              Internal Hire Menu
            </a>
          </span>
        </div>
        <div>
          <span>
            <FooterIcon
              icon={faFilePdf}
              style={{ marginRight: "0.5rem" }}
            ></FooterIcon>
            <a
              href="https://drive.google.com/file/d/1EBbfyuASFn3Z-4YGw92vKm9HnAbk0i7V/view?usp=sharing"
              alt="View External Hire Menu PDF"
              className="  mb1"
            >
              External Hire Menu
            </a>
          </span>
        </div>
      </ColFlex>
    </SideBySideContainer>
  );
}

export default function Kitchen() {
  return (
    <Container>
      <BorderImg
        className="mb1"
        src="kitchenlogo.webp"
        alt="Lubber Kitchen logo"
        style={{ maxHeight: "100px", objectFit: "contain" }}
      />

      <p className="tac mb1">
        Our café and restaurant, located just downstairs from the main venue.
      </p>
      <div className="mb1">
        <p className="tac" style={{ marginBottom: 0 }}>
          Thursday
        </p>
        <p className="tac">5pm-10pm</p>

        <p className="tac" style={{ marginBottom: 0 }}>
          Friday
        </p>
        <p className="tac">12pm-10pm</p>
        <p className="tac" style={{ marginBottom: 0 }}>
          Saturday
        </p>
        <p className="tac">12pm-10pm</p>
        <p className="tac">Walk-ins welcome</p>
      </div>

      <KitchenLinks />

      <div className="mb1">
        <p className="tac">
          <FooterIcon
            icon={faEnvelope}
            style={{ marginRight: "0.5rem" }}
          ></FooterIcon>
          <a
            href="mailto:kitchen@thelubberfiend.com"
            alt="Email Lubber Kitchen"
            className="  mb1"
          >
            kitchen@thelubberfiend.com
          </a>
        </p>
      </div>

      <div className="mb1">
        <ImageGallery
          showPlayButton={false}
          showFullscreenButton={false}
          showBullets
          showNav={true}
          showThumbnails={false}
          items={images}
          autoPlay
        />
      </div>

      <SideBySideContainer>
        <ColFlex>
          <p className="">
            With a frequently changing menu inspired by European cookery, Lubber
            Kitchen create considered and generous seasonal plates to share,
            family style. Focused on quality veg, sustainable fish and meat,
            alongside our own pickles and ferments.
          </p>
          <p>
            Drinks include foraged infusions, cocktails, speciality coffee and
            soft drinks as well as a thoughtful selection of natural wines and
            beers.
          </p>
          <p>
            Lubber Kitchen is open from early afternoon through to late evening
            for drinks, snacks, small plates and feasting. Guests can sit up at
            the chef's bar or find a quiet corner, where a host team offers
            warm, family-style service.
          </p>
          <p className="">
            Both daytime and evening, bookings and walk-ins are welcome.
          </p>
        </ColFlex>

        <ColFlex className="tac">
          <div className="mb1">
            <ImageGallery
              showPlayButton={false}
              showFullscreenButton={false}
              showBullets
              showNav={true}
              showThumbnails={false}
              items={foodImages}
              autoPlay
            />
          </div>
        </ColFlex>
      </SideBySideContainer>

      <BorderImg
        className="mb1"
        style={{
          filter: "invert(100%)",
          "-webkit-transform": "scaleX(-1)",
          transform: "scaleX(-1)",
          height: "100px",
          objectFit: "contain",
        }}
        src="horizontal-border-1.png"
        alt="Decorative border"
      />

      <FlexContainer>
        <TeamImg
          src="team2.webp"
          alt="Lubber Kitchen team"
          className="mb1"
          style={{ maxHeight: "500px", objectFit: "contain" }}
        />
        <TeamImg
          src="team3.webp"
          alt="Lubber Kitchen team"
          className="mb1"
          style={{ maxHeight: "500px", objectFit: "contain" }}
        />
      </FlexContainer>

      <h2 className="tac">Pull Up A Pew</h2>

      <p className="tac">
        Lubber Kitchen is also home to Slack's Radio, broadcasting daily from
        our new studio.
      </p>
      <p className="tac">
        Any profit we make goes straight back into supporting our grassroots
        music venue.
      </p>

      <FlexContainer>
        <TeamImg
          src="food5.webp"
          alt="Food at Lubber Kitchen"
          className="mb1"
          style={{ maxHeight: "500px", objectFit: "contain" }}
        />
        <TeamImg
          src="radio.webp"
          alt="Slack's Radio studio"
          className="mb1"
          style={{ maxHeight: "500px", objectFit: "contain" }}
        />
      </FlexContainer>

      <KitchenLinks />
    </Container>
  );
}
